export default __webpack_public_path__ + "static/8-f8a7f2e77219ac314ee71e43b144ff10.jpg";